export default __webpack_public_path__ + "static/media/checkwarning.6efe67cf.svg";